import { useState } from "react";
import moment from "moment";
import {
  fechasModalExportacion,
  initValuesFechasModalExportacion,
} from "../models/ModalExportacion/modalexportation.model";
import apiParticipantes from "../api/Participantes/api-participantes";
import fileDownload from "js-file-download";
import apiJurados from "../api/Jurados/api-jurados";
import { openNotification } from "../utils/Notifactions";

export const useModalExportacion = () => {
  const [estadoDatos, setEstadoDatos] = useState("");
  const [fechasExportacion, setFechasExportacion] = useState<fechasModalExportacion>(initValuesFechasModalExportacion);

  const exportarDatos = async (modulo: string, consulta: string) => {

    if (fechasExportacion.fechaDesde > fechasExportacion.fechaHasta) {
      return openNotification({ titulo: "Error", descripcion: "la fecha fin debe ser mayor a la de inico", placement: "bottomRight" });
    }

    if (moment().isBefore(moment(fechasExportacion.fechaHasta).add(1, "hours"))) {
      return openNotification({
        titulo: "Error",
        descripcion: "No puedes escoger fechas mayores a hoy",
        placement: "bottomRight",
      });
    }

    const fecha_inicio = moment(fechasExportacion.fechaDesde).format("YYYY-MM-DD");
    const fecha_fin = moment(fechasExportacion.fechaHasta).format("YYYY-MM-DD");

    if (modulo === "Participante" && consulta === "1") {
      const postulaciones = await apiParticipantes.generarReportePostulaciones(estadoDatos, fecha_inicio, fecha_fin);
      if (postulaciones != null) fileDownload(postulaciones, 'reporte.xlsx');
    } else if (modulo === "Jurados" && consulta === "1") {
      const jurados = await apiJurados.obtenerProyectosJuradosCriteriosReporte();
      fileDownload(jurados.fileURL, 'reporte.xlsx');
    } else if (modulo === "Postulaciones" && consulta === "1") {
      const postulaciones = await apiParticipantes.generarReporteSeguimientoPostulaciones(estadoDatos, fecha_inicio, fecha_fin);
      fileDownload(postulaciones, 'reporte.xlsx');
    }
  };

  return {
    fechasExportacion,
    setFechasExportacion,
    estadoDatos,
    setEstadoDatos,
    exportarDatos,
  };
};
